import { ServerConfig } from './server_config';

export const SERVER_CONFIG: ServerConfig = {};

